import styled from 'styled-components';

import { IconButtonStyle, InputStyle, RadioStyle } from './form-styles';

export const ContentLayout = styled.div`
  padding: 72px 16px;
  padding-bottom: 92px;
  position: relative;
  &.with-navbar {
    padding-top: calc(72px + 20px);
  }
  &.in-assistance {
    padding-top: 100px;
  }
  .back-arrow {
    position: absolute;
    top: 65px;
    left: 30px;
    cursor: pointer;
  }

  &.no-bottom {
    padding-bottom: 0;
    min-height: 100vh;
    height: 100vh;
  }
  .m-4px {
    margin-bottom: 4px;
  }
  .m-8px {
    margin-bottom: 8px;
  }

  .m-12px {
    margin-bottom: 12px;
  }
  .m-24px {
    margin-bottom: 24px;
  }

  .m-40px {
    margin-bottom: 40px;
  }
  .m-82px {
    margin-bottom: 82px;
  }
  .m-120px {
    margin-bottom: 120px;
  }
  .m-t-16px {
    margin-top: 16px;
  }
  .m-t-25px {
    margin-top: 25px;
  }
  .m-t-40px {
    margin-top: 40px;
  }
  .MuiFormGroup-root {
    &.row {
      display: flex;
      flex-direction: row;
    }
  }
  ${InputStyle}
  ${RadioStyle}
  ${IconButtonStyle}
`;

export const FormLayout = styled.div`
  display: grid;
  gap: 12px;
  width: 100%;
  outline: none;
`;

export const AuthHeader = styled.div`
  margin-bottom: 56px;
  .auth-header-title {
    text-align: center;
    margin-top: 24px;
    padding: 0 24px;
  }
  .auth-header-text {
    text-align: center;
    margin-top: 24px;
  }
`;

export const CustomTabs = styled.div`
  overflow-x: auto;
  min-height: 64px;
  .MuiTabs-root {
    margin-bottom: 16px;
  }
  .MuiTabs-flexContainer {
    justify-content: flex-start;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .MuiTab-root {
    min-width: unset;
    width: max-content;
    padding: 6px 0;

    &:not(:last-child) {
      margin-right: 24px;
    }
  }
  .MuiPaper-root,
  .MuiStep-root {
    padding: 0;
  }
  .MuiTypography-root {
    font-size: 12px;
    line-height: 16px;
  }
`;
